import { userInfoStore } from "Stores";
import { debounce } from "lodash";
import { makeObservable, observable } from "mobx";

interface TableWidthRecord {
  dataIndex: string;
  width: number;
}

export type TableWidthPayload = TableWidthRecord[];

export class TableWidthStore {
  data = new Map<string, TableWidthRecord[]>();
  save: Function = null;
  constructor() {
    makeObservable(this, {
      data: observable,
    });
    this.init();
    this.save = debounce(this._save, 300);
  }

  /** initializes data that was preserved in localStorage */
  init() {
    const namespace = this.getNamespace();
    const storeJson = localStorage.getItem(namespace);
    if (storeJson) {
      const store = JSON.parse(storeJson);
      this.data = new Map(store);
    }
  }

  set(tableName: string, record: TableWidthRecord[]) {
    this.data.set(tableName, record);
    this.save();
  }

  get(tableName: string) {
    return this.data.get(tableName);
  }

  getRecordItem(tableName: string, dataIndex: string) {
    const config = this.data.get(tableName);
    if (config) {
      return config.find((item) => item.dataIndex === dataIndex);
    } else {
      return undefined;
    }
  }

  /** saves data to localStorage */
  _save() {
    const namespace = this.getNamespace();
    localStorage.setItem(namespace, JSON.stringify(Array.from(this.data.entries())));
  }

  getNamespace() {
    const userId = userInfoStore.userID;
    let namespace: string;
    if (userId) {
      namespace = `t_widths_${userId}`;
    } else {
      namespace = `t_widths_guest`;
    }
    return namespace;
  }
}

export const tableWidthStore = new TableWidthStore();
